import React from "react";
import {amenityTypeService} from "../jwt/_services/hotel/amenityTypeService";

export const amenityTypeProvider = {
    getOptions,
    getItem
};

async function getOptions() {
    try {
        const listItems = await amenityTypeService.search(0, 100);
        return listItems?.data.map((itemData) => {
            const {id, code} = itemData
            return (
                {
                    id: id,
                    value: code ,
                    label: <div><label>{code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}


async function getItem(id) {
    try {
        const item = await amenityTypeService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}